import { Route } from 'react-router-dom';

import { RoutesInternal } from 'theSource/components';
import { InboxFeedPage } from './InboxFeedPage';
import { InboxMessagePage } from './InboxMessagePage';

export const Inbox = () => {
  return (
    <RoutesInternal>
      <Route path="/" element={<InboxFeedPage />} />
      <Route path=":messageId" element={<InboxMessagePage />} />
    </RoutesInternal>
  );
};
